export const DATA_LIMIT = 10;

export const PINTEREST_ACCOUNT_FIELDS_LIST: any = [
    {attribute: "profile_image", label: "Profile Image", cssClass: 'w-24 text-center', isImage: true},
    {
        attribute: "username",
        label: "Details",
        cssClass: 'w-48',
        secondaryAttributes: ['id', 'account_type', 'website_url']
    },
    {attribute: "business_name", label: "Business Name", cssClass: 'w-1/6'},
    {attribute: "about", label: "About", cssClass: ''},
    {attribute: "board_count", label: "Board Count", cssClass: 'text-center'},
    {attribute: "pin_count", label: "Pin Count", cssClass: 'text-center'},
    {attribute: "monthly_views", label: "Monthly Views", cssClass: 'text-center'},
    {attribute: "follower_count", label: "Follower Count", cssClass: 'text-center'},
    {attribute: "following_count", label: "Following Count", cssClass: 'text-center'},
];


export const PINTEREST_ACCOUNT_INPUT_FIELDS: any = [
    {attribute: "business_name", label: "Business Name", type: 'text', group: 'detail', cssClass: ''},
    {attribute: "username", label: "Username", type: 'text', group: 'detail', cssClass: ''},
    {attribute: "profile_image", label: "Profile Image", type: 'text', group: 'detail', cssClass: ''},
    {attribute: "account_type", label: "Account Type", type: 'text', group: 'detail', cssClass: ''},
    {attribute: "about", label: "About", type: 'text', group: 'detail', cssClass: ''},
    {attribute: "website_url", label: "Website Url", type: 'text', group: 'detail', cssClass: ''},
    {attribute: "id", label: "Id", type: 'text', group: 'detail', cssClass: ''},
    {attribute: "pin_count", label: "Pin Count", type: 'text', group: 'detail', cssClass: ''},
    {attribute: "follower_count", label: "Follower Count", type: 'text', group: 'detail', cssClass: ''},
    {attribute: "board_count", label: "Board Count", type: 'text', group: 'detail', cssClass: ''},
    {attribute: "monthly_views", label: "Monthly Views", type: 'text', group: 'detail', cssClass: ''},
    {attribute: "following_count", label: "Following Count", type: 'text', group: 'detail', cssClass: ''},
];

export const PINTEREST_ACCOUNT_FILTER_FIELDS: any = [
    {
        attribute: "accountId",
        label: "Pinterest Account",
        type: 'select',
        group: 'filter',
        cssClass: '',
        options: [],
        isDynamic: true
    },
];
